'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSearchDescription = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _url = require('./url');

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class to parse the OpenSearchDescription XML document and get the saerch URLs
 */
var OpenSearchDescription = exports.OpenSearchDescription = function () {
  /**
   * Create an OpenSearchDescription object
   * @param {object} values The object containing the parsed description
   * @param {string} [values.shortName] The short name of the OpenSearch service
   * @param {string} [values.description] The description of the service
   * @param {string} [values.tags] The associated tags of the service
   * @param {string} [values.contact] The contact information of the service
   * @param {OpenSearchUrl[]} [values.urls] The parsed URLs of the service
   * @param {string} [values.longName] The long name of the service
   * @param {object[]} [values.images] The associated images of the service
   * @param {object[]} [values.queries] Prepared queries for the service
   * @param {string} [values.developer] The developer information of the service
   * @param {string} [values.attribution] The attribution for the service
   * @param {string} [values.syndicationRight] Syndication rights for the service
   * @param {string} [values.adultContent] Information about the adult content of the service
   * @param {string} [values.language] The language settings for the service
   * @param {string} [values.outputEncoding] The output encoding
   * @param {string} [values.inputEncoding] The input encoding
   */
  function OpenSearchDescription(values) {
    _classCallCheck(this, OpenSearchDescription);

    this.shortName = values.shortName;
    this.description = values.description;
    this.tags = values.tags;
    this.contact = values.contact;
    this.urls = values.urls;
    this.longName = values.longName;
    this.images = values.images;
    this.queries = values.queries;
    this.developer = values.developer;
    this.attribution = values.attribution;
    this.syndicationRight = values.syndicationRight;
    this.adultContent = values.adultContent;
    this.language = values.language;
    this.outputEncoding = values.outputEncoding;
    this.inputEncoding = values.inputEncoding;
  }

  /**
   * Get the {@link OpenSearchUrl} for the given parameters, mime type and HTTP
   * method. Return the first matching URL or null.
   * @param {object} [parameters=null] An object containing search parameters
   * @param {string} [type=null] The mime-type for the URL
   * @param {string} [method='GET'] The preferred HTTP method of the URL
   * @returns {OpenSearchUrl|null}
   */


  _createClass(OpenSearchDescription, [{
    key: 'getUrl',
    value: function getUrl() {
      var urls = this.getUrls.apply(this, arguments);
      if (urls.length) {
        return urls[0];
      }
      return null;
    }

    /**
     * Get an array of {@link OpenSearchUrl} for the given parameters, mime type and HTTP
     * method.
     * @param {object} [parameters=null] An object containing search parameters
     * @param {string|Array} [type=null] The mime-type for the URL
     * @param {string|Array} [method=null] The preferred HTTP method of the URL
     * @returns {OpenSearchUrl[]}
     */

  }, {
    key: 'getUrls',
    value: function getUrls() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var urls = this.urls.filter(function (url) {
        return (0, _utils.find)(url.relations, function (rel) {
          return rel === 'results';
        });
      });

      if (type) {
        urls = urls.filter(function (url) {
          return Array.isArray(type) ? type.indexOf(url.type) > -1 : url.type === type;
        });
      }
      if (method) {
        urls = urls.filter(function (url) {
          return Array.isArray(method) ? method.indexOf(url.method) > -1 : url.method === method;
        });
      }

      if (parameters) {
        return urls.filter(function (url) {
          return url.isCompatible(parameters);
        });
      }
      return urls;
    }

    /**
     * Parse an OpenSearch Description XML Document.
     * @param {string} xml The XML String to parse.
     * @returns {OpenSearchDescription} The parsed description document
     */

  }, {
    key: 'serialize',


    /**
     * Serialize the OpenSearch description to a simple object.
     * @returns {object} The serialized description
     */
    value: function serialize() {
      return {
        shortName: this.shortName,
        description: this.description,
        tags: this.tags,
        contact: this.contact,
        urls: this.urls.map(function (url) {
          return url.serialize();
        }),
        longName: this.longName,
        images: this.images,
        queries: this.queries,
        developer: this.developer,
        attribution: this.attribution,
        syndicationRight: this.syndicationRight,
        adultContent: this.adultContent,
        language: this.language,
        outputEncoding: this.outputEncoding,
        inputEncoding: this.inputEncoding
      };
    }

    /**
     * Deserialize an OpenSearch description from an object.
     * @param {object} values The serialized description
     * @returns {OpenSearchDescription} The deserialized description
     */

  }], [{
    key: 'fromXml',
    value: function fromXml(xml) {
      var xmlDoc = (0, _utils.parseXml)(xml).documentElement;

      var values = {
        shortName: (0, _utils.getText)(xmlDoc, 'os', 'ShortName'),
        description: (0, _utils.getText)(xmlDoc, 'os', 'Description'),
        tags: (0, _utils.getText)(xmlDoc, 'os', 'Tags'),
        contact: (0, _utils.getText)(xmlDoc, 'os', 'Contact'),
        urls: (0, _utils.getElements)(xmlDoc, 'os', 'Url').map(function (node) {
          return _url.OpenSearchUrl.fromNode(node);
        }),
        longName: (0, _utils.getText)(xmlDoc, 'os', 'LongName'),
        images: (0, _utils.getElements)(xmlDoc, 'os', 'Image').map(function (node) {
          return {
            height: parseInt(node.getAttribute('height'), 10),
            width: parseInt(node.getAttribute('width'), 10),
            type: node.getAttribute('type'),
            url: node.textContent
          };
        }),
        queries: (0, _utils.getElements)(xmlDoc, 'os', 'Query').map(function (node) {
          var query = { role: node.getAttribute('role') };
          for (var i = 0; i < node.attributes.length; ++i) {
            var attribute = node.attributes[i];
            query[attribute.name] = attribute.value;
          }
          return query;
        }),
        developer: (0, _utils.getText)(xmlDoc, 'os', 'Developer'),
        attribution: (0, _utils.getText)(xmlDoc, 'os', 'Attribution'),
        syndicationRight: (0, _utils.getText)(xmlDoc, 'os', 'SyndicationRight'),
        adultContent: (0, _utils.getText)(xmlDoc, 'os', 'AdultContent'),
        language: (0, _utils.getText)(xmlDoc, 'os', 'Language'),
        outputEncoding: (0, _utils.getText)(xmlDoc, 'os', 'OutputEncoding'),
        inputEncoding: (0, _utils.getText)(xmlDoc, 'os', 'InputEncoding')
      };
      return new OpenSearchDescription(values);
    }
  }, {
    key: 'deserialize',
    value: function deserialize(values) {
      return new OpenSearchDescription((0, _utils.assign)({}, values, {
        urls: values.urls.map(function (urlDesc) {
          return _url.OpenSearchUrl.deserialize(urlDesc);
        })
      }));
    }
  }]);

  return OpenSearchDescription;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/description.js